const rankingItems = [
  { rank: 1, title: '星辰大海', tag: '热播剧', hot: '987万热度', desc: '年度科幻巨制，口碑持续走高' },
  { rank: 2, title: '暗夜追踪', tag: '新上线', hot: '856万热度', desc: '悬疑刑侦题材，全网热追' },
  { rank: 3, title: '欢乐喜剧人·第七季', tag: '综艺', hot: '732万热度', desc: '爆笑不断，周末必看综艺' },
  { rank: 4, title: '古剑传说', tag: '飙升榜', hot: '689万热度', desc: '古装仙侠大剧，画风唯美' },
  { rank: 5, title: '极限冒险家', tag: '纪录片', hot: '521万热度', desc: '全球探险纪实，视觉震撼' },
  { rank: 6, title: '都市夜语', tag: '热播', hot: '478万热度', desc: '都市情感故事，引发共鸣' },
  { rank: 7, title: '动漫英雄传', tag: '动漫', hot: '412万热度', desc: '热血战斗番，每周更新中' },
];

export default function RankingSection() {
  const getRankIcon = (rank: number) => {
    if (rank === 1) return <i className="ri-vip-crown-fill text-accent-500 text-lg"></i>;
    if (rank === 2) return <i className="ri-vip-crown-fill text-secondary-400 text-lg"></i>;
    if (rank === 3) return <i className="ri-vip-crown-fill text-primary-400 text-lg"></i>;
    return <span className="text-sm font-bold text-foreground-400 w-5 text-center">{rank}</span>;
  };

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-fire-line"></i>
            <span className="whitespace-nowrap">实时热度追踪</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">热度榜单</h2>
          <p className="mt-2 text-sm text-foreground-500">全网热播影视实时排行，不错过每一个热门</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200/60 transition-colors cursor-pointer group"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 flex-shrink-0">
                {getRankIcon(item.rank)}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-500 transition-colors">{item.title}</h3>
                  <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium whitespace-nowrap">{item.tag}</span>
                </div>
                <p className="text-xs text-foreground-500 mt-1 truncate">{item.desc}</p>
                <span className="text-xs text-primary-500 font-medium mt-1 inline-block">{item.hot}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}